import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const DashboardIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M3.75 3.75H9.75V9.75H3.75V3.75Z" fill="none" stroke="var(--iconFill)" strokeLinecap="round" strokeWidth="1.5" />
            <path d="M3.75 14.25H9.75V20.25H3.75V14.25Z" fill="none" stroke="var(--iconFill)" strokeLinecap="round" strokeWidth="1.5" />
            <path d="M14.25 3.75H20.25V9.75H14.25V3.75Z" fill="none" stroke="var(--iconFill)" strokeLinecap="round" strokeWidth="1.5" />
            <path d="M14.25 14.25H20.25V20.25H14.25V14.25Z" fill="none" stroke="var(--iconFill)" strokeLinecap="round" strokeWidth="1.5" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const DashboardIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M3.75 3.75H9.75V9.75H3.75V3.75Z" fill="none" stroke="var(--iconFill)" strokeLinecap="round" strokeWidth="1.5" />
            <path d="M3.75 14.25H9.75V20.25H3.75V14.25Z" fill="none" stroke="var(--iconFill)" strokeLinecap="round" strokeWidth="1.5" />
            <path d="M14.25 3.75H20.25V9.75H14.25V3.75Z" fill="none" stroke="var(--iconFill)" strokeLinecap="round" strokeWidth="1.5" />
            <path d="M14.25 14.25H20.25V20.25H14.25V14.25Z" fill="none" stroke="var(--iconFill)" strokeLinecap="round" strokeWidth="1.5" />
        </SvgIcon>
    );
};
